export default __webpack_public_path__ + "static/media/Finger_lickInDesk.a7d05386.svg";